module.exports = __webpack_public_path__ + "static/map-23673861c38f6ded4502c5480ce677cf.png";